import { jsonFetch } from "@/lib/helpers";
import { CoordinatesData } from "../../../models/address-suggestions/coordinate-data.model";
import { geocodeAddressUrl } from "./api-url.constants";
import { CoordinatesDatasApiDTO } from "./dtos/coordinates-data.api.dto";
import { coordinatesDataMapper } from "./mappers/coordinates-data.mapper";

export interface GeocodeAddressParams {
  address: string;
  countryName: string;
}

export const getCoordinatesData = async ({
  address,
  countryName,
}: GeocodeAddressParams): Promise<CoordinatesData> => {
  const response = await jsonFetch<CoordinatesDatasApiDTO>(geocodeAddressUrl(address, countryName));
  return coordinatesDataMapper(response.data);
};
